import React from "react";
import MainStyle from "../../MainStyle";
import Btn from "./Btn";
import Div from "../lib/Div";
import P from "../lib/P";
import AntDesign from "@expo/vector-icons/AntDesign";
import {LinearGradient} from "expo-linear-gradient";

type Props = { title: string, px: number, onCancel: () => void };

const ModalHeaderFS = (props: Props) => {
  const {title, px} = props;

  return (
    <LinearGradient colors={["#131314", "#252526"]} start={{x: 0, y: 1}} end={{x: 0, y: 0}}
                    style={[{paddingHorizontal: px}, MainStyle.p_y_12, MainStyle.row, MainStyle.a_i_c]}>
      <Div w={28} h={28}/>

      <Div column gap={12} flex={1}>
        <Div row justifyContent="space-between" alignItems="center">
          {title && <P flex={1} fontFamily="DavisSans-Medium" fs={20} lh={30} ta="center">{title}</P>}
        </Div>
      </Div>

      <Btn w={28} h={28} bg="#252526" onPress={props.onCancel} alignItems="center" justifyContent="center" rounded={15}>
        <AntDesign name="close" size={16} color="white"/>
      </Btn>
    </LinearGradient>
  );
};

export default ModalHeaderFS;
